import { Icon, Button } from '@a-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useLayoutEffect } from 'react';
import { useParams } from "react-router-dom";
import { fetchTask, fetchTaskAttachments } from '../../store/slices/tasksReducer'
import { formatDateTime } from '../../helpers/dateTime.helper';
import { getCurrentAssignment, getCurrentAssignmentForUser } from '../../helpers/task.helper';
import { getTaskTypesForDomain, getDomains } from '../../store/slices/domainsReducer'
import { getDefinition, clearForm } from '../../store/slices/formsReducer'
import { openModal } from '../../store/slices/modalReducer'
import Assignments from '../Assignments/Assignments'
import Actions from './Actions'
import FileUpload from './FileUpload'
import Html from '../Html/Html'
import Location from '../Location/Location'
import Map from './Map'
import Tabs from '../Home/Tabs'
import Notes from './Notes'
import Photos from './Photos'
import '../../styles/task.scss';

const Task = (props) => {
  const dispatch = useDispatch();
  const { taskId } = useParams();
  const { task, files, attachments } = useSelector(state => state.tasks);
  const { user } = useSelector(state => state.user);
  const { taskTypes } = useSelector(state => state.domains);
  const { formDefinition } = useSelector(state => state.forms);
  const [taskType] = taskTypes.filter(({id}) => id === task.taskTypeId);
  const currentAssignmentForUser = getCurrentAssignmentForUser(task.taskAssignments, user.userName);
  const currentAssignment = getCurrentAssignment(task.taskAssignments);
  const hasForm = task?.formAndSurveyData?.templateId;
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  });
  useEffect(() => {
    dispatch(clearForm());
    dispatch(fetchTask(taskId));
    dispatch(fetchTaskAttachments(taskId));
  }, [dispatch, taskId]);
  useEffect(() => {
    dispatch(getDomains());
  }, [dispatch]);
  useEffect(() => {
    if(task.domainId) dispatch(getTaskTypesForDomain(task.domainId));
  }, [dispatch, task.domainId]);
  useEffect(() => {
    if(hasForm && task?.formAndSurveyData?.templateId) dispatch(getDefinition(task?.formAndSurveyData?.templateId));
  }, [dispatch, taskType?.formAndSurveyDefinitionId, hasForm, task]);
  return (<>
    <div className="u-bg-light">
      <Tabs hideTabs={true} taskName={task.name} />
    </div>
    <div className="u-container u-margin-top-xx u-margin-bottom-lg u-bg-white taskdetail" role="main">
      <div className="row">
        <div className="col-xs-12 u-margin-top">
          { task?.locationDuringAssignment?.xCoordinate !== "" && task?.locationDuringAssignment?.xCoordinate && <Map /> }
        </div>
        <div className="col-xs-12 u-margin-top o-task__action-buttons">
          <Actions currentAssignment={currentAssignmentForUser || currentAssignment} />
        </div>
        { task?.formAndSurveyData?.requiredOnFinish && task?.formAndSurveyData?.templateId && !task.formAndSurveyData.responseJson && task.active && <div className="col-xs-12 u-margin-top">
          <div role="alertdialog" aria-labelledby="alert-inline-danger" className="m-alert m-alert--inline m-alert--danger">
            <Icon name="ai-alert-triangle" className="m-alert__icon"/>
            <h5 id="alert-inline-danger" className="paragraph">Formulier invullen</h5>
            <p>Om deze taak te kunnen voltooien, dien je het bijgevoegde formulier in te vullen.</p>
          </div>
        </div> }
        { task?.formAndSurveyData?.requiredOnHold && task?.formAndSurveyData?.templateId && !task.formAndSurveyData.responseJson && task.active && <div className="col-xs-12 u-margin-top">
          <div role="alertdialog" aria-labelledby="alert-inline-danger" className="m-alert m-alert--inline m-alert--danger">
            <Icon name="ai-alert-triangle" className="m-alert__icon"/>
            <h5 id="alert-inline-danger" className="paragraph">Formulier invullen</h5>
            <p>Om deze taak te kunnen pauzeren, dien je het bijgevoegde formulier in te vullen.</p>
          </div>
        </div> }
        { task?.formAndSurveyData?.requiredOnStart && task?.formAndSurveyData?.templateId && !task.formAndSurveyData.responseJson && !task.active && <div className="col-xs-12 u-margin-top">
          <div role="alertdialog" aria-labelledby="alert-inline-danger" className="m-alert m-alert--inline m-alert--danger">
            <Icon name="ai-alert-triangle" className="m-alert__icon"/>
            <h5 id="alert-inline-danger" className="paragraph">Formulier invullen</h5>
            <p>Om deze taak te kunnen starten, dien je het bijgevoegde formulier in te vullen.</p>
          </div>
        </div> }
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8 u-margin-top">
          <h6 className="u-margin-bottom-xs">Locatie</h6>
          <p className="u-margin-bottom-xs">
            <Location location={task.locationDuringAssignment} />
          </p>
          { task.vehicleReservation?.vehicleDescription && <>
            <h6 className="u-margin-bottom-xs">Voertuig</h6>
            <p className="u-margin-bottom-xs">
              <Icon name="ai-car-retro-2" className="u-margin-right-xxs"/>{task.vehicleReservation?.vehicleDescription.split("|||").pop()}
            </p>
          </>
          }
          <h6 className="u-margin-bottom-xs">Uiterste datum</h6>
          <p className="u-margin-bottom-xs">
            <Icon name="ai-calendar-3" className="u-margin-right-xxs"/>{formatDateTime(task.dueDate)}
          </p><br/>
          <h6 className="u-margin-bottom-xs">Beschrijving</h6>
          <div className="u-margin-bottom-xs">
            {!!task.description
              ? <Html>{task.description}</Html>
              : <p className="u-text-light">Niet gespecifieerd</p>}
          </div>
          </div>
          <div className="col-xs-12 col-md-4 u-margin-top">
            <div className="u-margin-bottom">
              <h6 className="u-margin-bottom-xs">Taak ID</h6>
              <p>{task?.id}</p>
            </div>
            <div className="u-margin-bottom">
              <h6 className="u-margin-bottom-xs">Taak type</h6>
              <Icon name="ai-copy-paste-1" className="u-margin-right-xxs"/>{task?.taskType}
            </div>
            <div className="u-margin-bottom">
              <h6 className="u-margin-bottom-xs">Gemaakt door</h6>
              <p>{task?.createdBy}</p>
            </div>
            <div className="u-margin-bottom">
              <h6 className="u-margin-bottom-xs">Domein</h6>
              <p>{task.domain}</p>
            </div>
            <div className="u-margin-bottom">
              <h6 className="u-margin-bottom-xs">Toegekende personen</h6>
              <Assignments assignments={task.taskAssignments} />
            </div>
            <div className="u-margin-bottom-xs">
            <h6 className="u-margin-bottom-xs">Planning</h6>
              { task.plannedStartDate && <p className="u-margin-bottom-xxs"><strong>Van</strong> {formatDateTime(task.plannedStartDate)} <br/></p> }
              { task.plannedEndDate && <p><strong>Tot</strong> {formatDateTime(task.plannedEndDate)} </p>}
            </div>
            <div className="u-margin-bottom">
              <Button
                size="small"
                emphasis="low"
                aria-label="Open Planning"
                addOn={{
                  type: "icon",
                  align: "left",
                  iconProps: {
                    name: "ai-add",
                  },
                }}
                onClick={() => {
                  dispatch(openModal('Planning'))
                }}
              >
                Planning toevoegen
              </Button>
            </div>
          </div>
        </div>
      <hr/>
      <div className="row">
        <div className="col-xs-12 col-md-8 u-margin-top">
          { attachments && attachments.length > 0  &&
            <>
            <h5 className="u-margin-bottom-xs">Foto's</h5>
            <Photos />
            </>
          }
          { files && files.length > 0  &&
            <>
            <h5 className="u-margin-bottom-xs">Bestanden</h5>
            <ul className="a-list a-list--lined u-margin-bottom-xs">
              { files && files.map((file) => {
                return <li key={file.id} className="a-list__item">
                  <span className="a-list__content">
                    <Icon name="ai-office-file-text" className="m-alert__icon"/>
                    <span className="a-list__text"><a href={file.data.downloadUrl}>{ file.data.fileName }</a></span>
                  </span>
                </li>
              }) }
            </ul>
            </>
          }
          <h6 className="u-margin-bottom-xs">Bijlage uploaden</h6>
          <FileUpload />
          { hasForm && <div id="form" className="u-margin-bottom">
            <h5 className="u-margin-bottom-xs">Formulier</h5>
            { !formDefinition?.template?.content?.name && <span className="a-spinner" role="alert">
              <span className="a-spinner__circle">
                <span className="u-screen-reader-only">Fetching data...</span>
              </span>
            </span>
            }
            { formDefinition?.template?.content?.name && <div className="u-margin-bottom">

              <Button
                type="primary"
                size="medium"
                aria-label="Open Form"
                addOn={{
                  type: "icon",
                  align: "left",
                  iconProps: {
                    name: "ai-common-file-text",
                  },
                }}
                onClick={() => {
                  dispatch(openModal('Form'))
                }}
              >
                Formulier
              </Button>
            </div>
            }
          </div>
          }
          { task.tags?.length > 0 &&  <>
            <h5 className="u-margin-bottom-xs">Tags</h5>
            { task.tags.map((tag) => <div key={tag.id} className="m-tag u-margin-right-xxs">
              <div className="m-tag__label">{tag.name}
            </div></div>)}
            </>
          }
        </div>
        <div className="col-xs-12 u-margin-top-xs">
          <h5 className="u-margin-bottom-xs u-margin-top-xl">Notities</h5>
          <Notes taskId={taskId} />
        </div>
      </div>
    </div>
  </>);
};

export default Task;
